import React from "react";
import { Link } from "react-router-dom";
import Finger from "./image/finger.png";
import Gear from "./image/gear.png";

class TrainBtn extends React.Component {
  render() {
    return (
      <div className="banner">
        <div className="main-container">
          <Link
            to={{
              pathname: "/measurement/pushup",
            }}
            className="main-button1"
          >
            <button className="button">
              <p>측정 감독</p>
              <p>Measure supervision</p>
              <img src={Finger} alt="손가락" />
            </button>
          </Link>
          <Link
            to={{
              pathname: "/QRread",
              state: {
                to: "/UserTrain",
                text: "체력 측정",
                cancel: "/MainTrain",
              },
            }}
            className="main-button2"
          >
            <button className="button">
              <p>체력 측정</p>
              <p>fitness measurement</p>
              <img src={Finger} alt="손가락" />
            </button>
          </Link>
        </div>
        <div className="bottom">
          <Link to="/Setting" className="main-button4">
            <button className="button">
              <img src={Gear} alt="설정" />
            </button>
          </Link>
        </div>
      </div>
    );
  }
}

export default TrainBtn;
